module.exports = __webpack_public_path__ + "img/hero-5-alu-guide-top.0a6d1a35.png";